export { CandidateProfileModal } from './CandidateProfileModal';
export { default } from './CandidateProfileModal';
